module.exports = __webpack_public_path__ + "img/icon_blue.a555939.png";